"use client";
import { AuthHeader } from "@/components/layout/auth/Header";
import AuthLayout from "@/components/layout/web/AuthLayout";
import { useAuthContext } from "@/context/AuthContext";
import Link from "next/link";

const SignUpLayout = ({ children, dictionary }) => {
  const { user } = useAuthContext();
  return (
    <>
      <AuthLayout>
        <AuthHeader>
          {!user ? (
            <div className=' hidden md:block text-greyDark'>
              {dictionary.alreadyHaveAnAccount}{" "}
              <Link href='/signin' className='text-primary no-underline'>
                {dictionary.signIn}
              </Link>
            </div>
          ) : (
            <></>
          )}
        </AuthHeader>
        {children}
      </AuthLayout>
    </>
  );
};

export default SignUpLayout;
